import types from './actionTypes';

export const loginRequest = payload => ({
    type: types.LOGIN_REQUEST,
    payload,
});

export const logoutRequest = () => ({
    type: types.LOGOUT_REQUEST,
});
